import {
  ListDivisionsV2Command,
  type ListDivisionsV2CommandInput,
  type ListDivisionsV2CommandOutput,
} from '@amzn/gbsa-orbit-typescript-client';
import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import { apiOrbitClient } from '../index';
import { v2DivisionKeys } from './keys';

/**
 * v2 React Query hook for listing divisions scoped to a business unit.
 * Query stays idle until both `businessUnitId` and `programId` are supplied.
 */
export const useDivisionsQuery = <TData = ListDivisionsV2CommandOutput>(
  input: Partial<ListDivisionsV2CommandInput>,
  options?: Omit<
    UseQueryOptions<ListDivisionsV2CommandOutput, Error, TData>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<TData> =>
  useQuery({
    ...options,
    queryKey: v2DivisionKeys.list(input),
    enabled: (options?.enabled ?? true) && !!input.businessUnitId && !!input.programId,
    queryFn: () => {
      if (!input.businessUnitId || !input.programId) {
        throw new Error('businessUnitId and programId are required to list divisions');
      }
      return apiOrbitClient.send(
        new ListDivisionsV2Command({
          ...input,
          businessUnitId: input.businessUnitId,
          programId: input.programId,
          isActive: true,
        }),
      );
    },
  });
